<template>
	<div class="stretch-layout">
		<login-to-see-more v-if="userStore.user.privacy_clubs !== PrivacyType.Public && !$auth.loggedIn" xs-tile sm-tile/>
		<data-loader v-else :url="`/v1/athletes/${userStore.user.id}/memberships`"
					 :params="params"
					 as-guest
					 on-scroll>

			<template #loading>
				<container custom-padding="px-8 md:px-0">
					<row tight>
						<column cols="6" sm="3" md="3" lg="2" v-for="clubLoader in userStore.user.clubs_count" :key="'club-loader-' + clubLoader">
							<club-card-skeleton/>
						</column>
					</row>
				</container>
			</template>

			<template v-slot="{data}">
				<container custom-padding="px-8 md:px-0">
					<row tight v-adapt:height="{selector: '.club-card', xs: 6, sm: 3, md: 3, lg: 2}">
						<column cols="6" sm="3" md="3" lg="2" v-for="(club, clubKey) in data" :key="'club-card-' + clubKey">
							<club-card :club="club" :to="$web('clubs.show', club._key)" class="club-card"/>
						</column>
					</row>
				</container>
			</template>

			<template #missing>
				<lazy-missing-info :icon="icons.club"
								   card xs-tile sm-tile class="min-h-200"
								   :text="$t('missing.user.memberships', {name: userStore.user.greeting_name})">
				</lazy-missing-info>
			</template>

		</data-loader>
	</div>
</template>

<script setup lang="ts">
import {mdiShieldAccountOutline} from '@mdi/js';
import {useUserStore} from "../../../store/user";
import {useIndexStore} from "../../../store";
import {PrivacyType} from "@spoferan/spoferan-ts-core";

const userStore = useUserStore();
const {t} = useI18n();
const route = useRoute();
const indexStore = useIndexStore();

const params = {relations: ['sportTypes']};

const icons = {
	club: mdiShieldAccountOutline
};

useMeta({
	title: userStore.buildPageTitle(t('view.users.clubs.index.title', {user: userStore.user.display_name})),
	description: t('view.users.clubs.index.description', {user: userStore.user.display_name}),
	noIndex: true
})

</script>

